import {DataProcessingAgreementModel} from '../../projects/models/data-processing-agreement-model';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {IDataProcessingAgreementHttpService} from './data-processing-agreement.http.service.interface';


@Injectable()
export class DataProcessingAgreementHttpService extends IDataProcessingAgreementHttpService {

   async acceptDataProcessingAgreement(dataProcessingAgreementId): Promise<void> {
        await firstValueFrom(
            this.httpClient.post(
                `${this.serverAddress}/v1/dataProcessingAgreements/${dataProcessingAgreementId}`,
                {}
            )
        );
    }

    async getLatestDataProcessingAgreement(): Promise<DataProcessingAgreementModel> {
        const response = await firstValueFrom(
            this.httpClient.get<{ dataProcessingAgreement: DataProcessingAgreementModel }>(
                `${this.serverAddress}/v1/dataProcessingAgreements/latest`
            )
        );
        return response.dataProcessingAgreement;
    }


}
